import React from 'react';

const Main: React.FC = () => {
	return (
		<div className="flex justify-center items-center container mx-auto px-4">
			<h1 className="text-2xl font-bold">Welcome</h1>
		</div>
	);
};

export default Main;
